import { render, staticRenderFns } from "./roundModel.vue?vue&type=template&id=aa91af26&scoped=true&"
import script from "./roundModel.vue?vue&type=script&lang=js&"
export * from "./roundModel.vue?vue&type=script&lang=js&"
import style0 from "./roundModel.vue?vue&type=style&index=0&id=aa91af26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa91af26",
  null
  
)

export default component.exports